import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import Container from '../../styles/Container';
import BrowseCity from '../browse/BrowseCity';
import SearchHeader from '../SearchHeader';
import Footer from '../Footer';

export default class BrowseCityPage extends Component {
	render() {
		var region = this.props.match.params.province ? this.props.match.params.province : false;
		region =  region && region != "KwaZulu-Natal"  ? region.replace('-', ' ') : region
		const origin = typeof window !== 'undefined' ? window.location.origin : 'https://autoforest.co.za';
		const collectionPageSchema = {
			'@context': 'https://schema.org',
			'@type': 'CollectionPage',
			name: `Cars for sale in ${region || 'South Africa'} | Auto Forest`,
			description: `Find the best deals on cars in ${region || 'South Africa'} | Auto Forest`,
			url: typeof window !== 'undefined' ? window.location.href : '',
			isPartOf: { '@type': 'WebSite', name: 'Auto Forest', url: `${origin}/` },
			breadcrumb: {
				'@type': 'BreadcrumbList',
				itemListElement: [
					{ '@type': 'ListItem', position: 1, name: 'Home', item: `${origin}/` },
					{ '@type': 'ListItem', position: 2, name: 'Browse Cars', item: `${origin}/cars` },
					...(region ? [{ '@type': 'ListItem', position: 3, name: `Cars in ${region}`, item: typeof window !== 'undefined' ? window.location.href : '' }] : []),
				],
			},
		};

		return (
			<Container>
				<Helmet>
					<meta name="description" content={`Find the best deals on cars in ${region || 'South Africa'} | Auto Forest`} />
					<title>{`Cars for sale in ${region || 'South Africa'} | Auto Forest`}</title>
					<link rel="canonical" href={window.location.href} />
					<script type="application/ld+json">{JSON.stringify(collectionPageSchema)}</script>
				</Helmet>
				<SearchHeader visible={false} />
				<h2 style={{ textAlign: 'center' }}>Cities in {region || 'South Africa'}</h2>
				<BrowseCity province={region} />
				<Footer />
			</Container>
		);
	}
}
